export const APP_LOCAL_STORAGE_READY = "atgStorage/APP_LOCAL_STORAGE_READY";

export type AppLocalStorageReadyAction = {type: typeof APP_LOCAL_STORAGE_READY};

export const appLocalStorageReady = (): AppLocalStorageReadyAction => ({
    type: APP_LOCAL_STORAGE_READY,
});
